import { render, staticRenderFns } from "./AssignTodoModal.vue?vue&type=template&id=5b5f9dc7&"
import script from "./AssignTodoModal.vue?vue&type=script&lang=js&"
export * from "./AssignTodoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports